<template>
    <div id="restrito">

        <user-state v-slot:user="{ user }">
            <div v-if="user">
                <profile :user="user"/>
            </div>
            <login v-else/>
        </user-state>
    </div>
</template>

<script>
    import UserState from "@/components/UserState";
    import Profile from "@/components/Profile";
    import Login from "@/components/Login";

    export default {
        components: {UserState, Profile, Login}
    }
</script>